/* eslint @typescript-eslint/naming-convention: 0 */
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface WabunkaCheckAvailabilityParams {
  section_name: 'main_visual' | 'overview' | 'detail' | 'things_to_know' | 'cta_bar' | 'ai_chat';
}

export type WabunkaCheckAvailabilitySectionName = WabunkaCheckAvailabilityParams['section_name'];

const buildCheckAvailabilityParams = (sectionName: WabunkaCheckAvailabilitySectionName): WabunkaCheckAvailabilityParams => {
  return { section_name: sectionName };
};
/**
 * 発火タイミング：各セクションに設置してある「Check Availability」ボタンがクリックされた際
 */
export const sendGAWabunkaCheckAvailabilityEvent = (sectionName: WabunkaCheckAvailabilitySectionName) => {
  sendWabunkaGAEvent('check_availability', buildCheckAvailabilityParams(sectionName));
};
